import Fetch from '../utils/fetch';
import { settings } from '../settings';

export interface AccountInfo {
  accountId: number;
  name: string;
  category: 'COURIER' | 'SENDER' | 'NONE';
  companyNumber: string;
  email: string;
}

export const fetchMyAccount = async (): Promise<AccountInfo> => {
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/account/self`,
  });
  return response.json();
};
